module.exports = __webpack_public_path__ + "img/4.db78a4a6.png";